export type Testimonial = {
  /** Optional headline shown above the quote. */
  title?: string
  /** Separate paragraphs with a blank line (\n\n). */
  quote: string
  author: string
  role: string
  avatar?: string
}

export type CoachProfile = {
  name: string
  role: string
  bio: string
}

/**
 * Only real reviews from real volleyball coaches (with their permission).
 * The review sections only render when these arrays have items \u2014 keep them
 * empty until you have genuine buyer reviews to drop in.
 */
export const coachProfiles: CoachProfile[] = []

export const shortTestimonials: Testimonial[] = [
  {
    title: 'A Full Season of Volleyball Practices. Already Planned.',
    quote:
      'You don\u2019t need another library of drills to sort through.\n\nYou need to know what to run at practice today, how long each activity takes, and how to move your team from one drill to the next.\n\n52 Weeks of Volleyball Practice Plans gives you complete, timed sessions organized by skill, level, and stage of the season.\n\nOpen the plan. Set up the court. Start coaching.',
    author: 'Sarah M.',
    role: 'Austin, Texas, USA',
  },
  {
    title: '\u201cI Was Still Planning Practice Late at Night.\u201d',
    quote:
      'Every week, I had to figure out which drills to use, how to organize them, and how to fit everything into our practice time.\n\nI didn\u2019t need more drills to choose from. I needed a complete session I could actually use.\n\nHaving the plan laid out ahead of time would make that weekly scramble much easier.',
    author: 'Emily J.',
    role: 'Youth Volleyball Coach \u00b7 Phoenix, Arizona, USA',
  },
  {
    title: 'Less Time Figuring It Out. More Time Coaching.',
    quote:
      'A practice plan should do more than give you a list of exercises.\n\nIt should help you organize the court, keep players involved, and know what comes next.\n\nWith complete sessions and clear drill instructions, you have a structure to follow instead of having to assemble the practice yourself.\n\nMore structure for your practice. Less guesswork for you.',
    author: 'Jessica B.',
    role: 'San Diego, California, USA',
  },
  {
    title: 'One Practice Plan. Adjusted to Your Team\u2019s Level.',
    quote:
      'A team learning the fundamentals needs a different practice from a team working on rotations, transitions, and game situations.\n\nThat\u2019s why 52 Weeks of Volleyball Practice Plans organizes sessions around different stages of development.\n\nUse the level options to choose an appropriate starting point, then adapt the plan to your players, available court space, equipment, and competition schedule.\n\nA structured starting point for the team you coach today.',
    author: 'Lauren W.',
    role: 'Charlotte, North Carolina, USA',
  },
]

export const moreTestimonials: Testimonial[] = []

/**
 * Real words from real volleyball coaches describing the problem (NOT reviews
 * of this product). Leave empty until you have genuine, attributable quotes;
 * the pain-section quote block only renders when this has items.
 */
export type ForumQuote = { quote: string; context: string }

export const forumQuotes: ForumQuote[] = []
